import * as React from 'react'
import {ArrUtil, Util} from 'yougile-util'
import {Option} from './select'

interface Props {
  options: Option[]
  value?: string
  className?: string
  placeholder?: string
  onChange?: (newValue: string) => void
  disabled?: boolean
}

export const SingleSelect = (props: Props) => {
  const {
    className = '',
    placeholder,
    value = '',
    onChange = Util.noop,
    options,
    disabled = false
  } = props
  const bem = Util.bemFrom('single-select')
  const mainClass = bem() + ' ' + className
  const change = (e: React.ChangeEvent<HTMLSelectElement>) =>
    onChange(e.target.value)

  const groups = ArrUtil.groupBy(options, opt => opt.groupTitle)

  return (
    <select
      className={mainClass}
      value={value}
      onChange={change}
      disabled={disabled}
    >
      {placeholder && (
        <option value="" disabled={true}>
          {placeholder}
        </option>
      )}
      {(groups.get(undefined) ?? []).map(opt => (
        <option value={opt.value} key={opt.value}>
          {opt.label}
        </option>
      ))}
      {[...groups.keys()].map(groupTitle => {
        if (groupTitle === undefined) {
          return null
        }
        const gr = groups.get(groupTitle)
        return (
          <optgroup key={groupTitle} label={groupTitle}>
            {gr.map(opt => (
              <option value={opt.value} key={opt.value}>
                {opt.label}
              </option>
            ))}
          </optgroup>
        )
      })}
    </select>
  )
}
